module.exports = __webpack_public_path__ + "img/cp7_03.e41906e6.png";